/** @jsx h */
import { h } from 'preact'

import BlockchainProof from './BlockchainProofSection'
import EvidencedMeaning from './EvidencedMeaning'
import Footer from './Footer'
import JourneyClose from '../journeys/Close'
import MeaningSection from './MeaningSection'
import { ProofPointStickyHeader } from './StickyHeader'
import Feedback from '../feedback/Feedback'
import ThirdPartyVerification from './ThirdPartyVerification'
import StoryButtonList from './stories/StoryButtonList'
import ThemeSection from './ThemeSection'
import ThemeSectionV1 from './ThemeSectionV1'
import VerifierSection from './VerifierSection'

const CertificateCard = ({
  analyticsName,
  ipfsHash,
  name,
  description,
  inJourney,
  networkExplorerUrl,
  logoUrl,
  schemeUrl,
  subject,
  summaryArray,
  typeLabel,
  journeys,
  theme,
  onStoryClick,
  onAboutClick,
  showPoweredByProvenanceModal,
  uiVersion,
  claimStatus,
  validUntil
}) => {
  const orgName =
    subject &&
    (subject.type === 'User' || subject.type === 'Organization' ? subject.name : subject.organizationName)

  const analyticsContext = `${orgName}${subject && subject.name ? ' / ' + subject.name : ''}`
  const locale = window.provenance.locale

  return (
    <article
      class={`ClaimCard ClaimCard--evidence
        ${inJourney ? 'ClaimCard--inJourney' : ''}`}
    >
      <JourneyClose />
      <ProofPointStickyHeader title={name} type={typeLabel} logoUrl={logoUrl} claimStatus={claimStatus} />
      <div class={`ModalCard-content ${journeys.length ? 'ModalCard-content--flush' : ''}`}>
        <div class='ModalCard-theme'>
          {theme && locale === 'en' && (
            uiVersion > 1
              ? <ThemeSection {...theme} analyticsContext={analyticsContext} />
              : <ThemeSectionV1 {...theme} />
          )}
        </div>

        <StoryButtonList journeys={journeys} onStoryClick={onStoryClick} name={name} analyticsContext={analyticsContext} />

        <VerifierSection
          analyticsContext={analyticsContext}
          name={name}
          logoUrl={logoUrl}
          claimStatus={claimStatus}
          description={description}
          schemeUrl={schemeUrl}
          validUntil={validUntil}
        />

        {typeLabel && <ThirdPartyVerification claimType={typeLabel} />}

        <MeaningSection title={name} summaryArray={summaryArray} />

        {networkExplorerUrl &&
          <BlockchainProof
            url={networkExplorerUrl}
            hash={ipfsHash}
            type={typeLabel}
            analyticsContext={analyticsContext}
          />}

        {!ipfsHash && <EvidencedMeaning />}

        <Footer
          onAboutClick={onAboutClick}
          showPoweredByProvenanceModal={showPoweredByProvenanceModal}
        >
          <Feedback
            context='Proof Point - Certificate'
            organizationName={orgName}
            analyticsContext={analyticsContext}
            analyticsName={analyticsName}
          />
        </Footer>
      </div>
    </article>
  )
}

CertificateCard.defaultProps = {
  inJourney: false,
  ipfsHash: null,
  logoUrl: null,
  networkExplorerUrl: null,
  summaryArray: [],
  journeys: []
}

export default CertificateCard
